<template>
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M7.05025 7.05024L16.9497 16.9497M16.9497 7.05024L7.05025 16.9497" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
</template>

<script>
    export default {
        name: 'DeleteIcon'
    }
</script>